import type { ReadonlyRecord } from "@core/foundation/types";

import type { Category } from "@apis/calorie-grid/models";

interface CategoryMeta {
  readonly color: string;
  readonly label: string;
}

export const CATEGORY_META: ReadonlyRecord<Category, CategoryMeta> = {
  "dairy-eggs": { color: "var(--cat-dairy-eggs)", label: "Dairy & eggs" },
  "eating-out": { color: "var(--cat-eating-out)", label: "Eating out" },
  "fats-oils": { color: "var(--cat-fats-oils)", label: "Fats & oils" },
  "fruit-veg": { color: "var(--cat-fruit-veg)", label: "Fruit & veg" },
  "grains-bread": { color: "var(--cat-grains-bread)", label: "Grains & bread" },
  "meat-fish": { color: "var(--cat-meat-fish)", label: "Meat & fish" },
  "sugar-treats": { color: "var(--cat-sugar-treats)", label: "Sugar & treats" },
};

// @unsorted
export const CATEGORY_ORDER: readonly Category[] = [
  "meat-fish",
  "dairy-eggs",
  "grains-bread",
  "fruit-veg",
  "fats-oils",
  "sugar-treats",
  "eating-out",
];
